import { getCookie } from 'cookies-next';
import type { SessionState } from './types';

function getUserFromCookie() {
  const cookie = getCookie('@event-monitor-web:user-1.0.1');

  if (typeof cookie !== 'string') return null;

  try {
    return JSON.parse(cookie);
  } catch {
    return null;
  }
}

export const initialState: SessionState = {
  user: getUserFromCookie(),
};
